import { mapItemDetails } from '../view-item/reducer';

export default initData => {
    if (!initData.traderaShopProduct) {
        return {};
    }

    const { product, item } = initData.traderaShopProduct;

    return {
        product,
        itemDetails: mapItemDetails(item.itemDetails),
        loading: false
    };
};
